import { useEffect, useState } from "react"
import { AlertCircle, CheckCircle, Info, AlertTriangle } from "lucide-react"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { cn } from "@/lib/utils"

function MessageBox({ message, type = "info", duration = 3000 }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (message) {
      setVisible(true)
      const timer = setTimeout(() => {
        setVisible(false)
      }, duration)
      return () => clearTimeout(timer) // Clear timer if message changes or component unmounts
    } else {
      setVisible(false)
    }
  }, [message, duration]) // Depend on message and duration

  if (!visible || !message) {
    return null
  }

  const icons = {
    info: <Info className="h-4 w-4" />,
    success: <CheckCircle className="h-4 w-4" />,
    warn: <AlertTriangle className="h-4 w-4" />,
    error: <AlertCircle className="h-4 w-4" />,
  }

  const alertClasses = {
    info: "border-blue-500 bg-blue-500/10 text-blue-500",
    success: "border-green-500 bg-green-500/10 text-green-500",
    warn: "border-yellow-500 bg-yellow-500/10 text-yellow-500",
    error: "border-destructive bg-destructive/10 text-destructive",
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 max-w-md w-full animate-in fade-in slide-in-from-top-4 duration-300">
      <Alert className={cn("border", alertClasses[type] || alertClasses.info)}>
        <div className="flex items-center gap-2">
          {icons[type] || icons.info}
          <AlertDescription>{message}</AlertDescription>
        </div>
      </Alert>
    </div>
  )
}

export default MessageBox
